import * as React from 'react';
import { useTranslation, TFunction } from 'react-i18next';
import { connect } from 'react-redux';

import { Selectors } from 'sections/campaigns/state/rulesetSplitTests';
import { State } from 'store';
import { getOptions } from '../../utils/sortAndFilterOptions';
import TableRow from './tableRow';

export interface Props {
  splitTestIds: (translator: TFunction<'campaigns'>) => string[];
}

export const Table: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation('campaigns');
  const splitTestIds = props.splitTestIds(t);

  if (splitTestIds.length === 0) {
    return <div className="dashboardTableMessage">{t('table.noSplitTests')}</div>;
  }
  return (
    <div>
      {splitTestIds.map(id => (
        <TableRow key={`splitTestTable-${id}`} splitTestId={id} />
      ))}
    </div>
  );
};

export const mapState = (state: State): Props => {
  const options = (t: TFunction<'campaigns'>) => getOptions(state, t);
  return {
    splitTestIds: (t: TFunction<'campaigns'>) => Selectors.getEntityIds(state, options(t)),
  };
};

export default connect(mapState)(Table);
